import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import { Carousel, Checkbox, Col, Radio, Row, Button, Modal } from 'antd'
import { getDifference } from '../../store/action/event.action'
import EventDiffItem from './event.diff.item'
import _ from 'lodash'
import util from '../../util/util'
import { constants } from '../../constants'

const EventDiff = (props) => {
  const [showids, setIds] = useState([])
  const [ignoreids, setIgnoreids] = useState([])
  const [events, setEvents] = useState([])
  const [index, setIndex] = useState(0)

  useEffect(() => {
    props.getDiffs({
      customer: props.customer?._id,
      company: props.company?._id || props.customer?.company,
    })
  }, [])

  useEffect(() => {
    var array = []
    props.differences.forEach((difference) => {
      var { type, name } = difference
      difference.events.forEach((diffevent) => {
        if (
          diffevent.isUpdated &&
          (!diffevent.isSame || diffevent.isSame == null)
        )
          array.push({
            ...diffevent,
            type,
            name,
          })
      })
    })
    setEvents(array)
  }, [props.differences, props.importids])

  useEffect(() => {
    setIndex(0)
  }, [props.differences])

  const handleEventSelect = (id, flag, type) => {
    var iids = JSON.parse(JSON.stringify(props.importids))
    var index = _.findIndex(props.importids, { type })
    if (flag == 1) {
      iids[index].skipids = iids[index].skipids.filter((e) => e != id)
      iids[index].discardids = iids[index].discardids.filter((e) => e != id)
      iids[index].ids.push(id)
    } else if (flag == -1) {
      iids[index].ids = iids[index].ids.filter((e) => e != id)
      iids[index].discardids = iids[index].discardids.filter((e) => e != id)
      iids[index].skipids.push(id)
    } else if (flag == 0) {
      iids[index].ids = iids[index].ids.filter((e) => e != id)
      iids[index].skipids = iids[index].skipids.filter((e) => e != id)
      iids[index].discardids.push(id)
    }
    props.setImportIds(iids)
  }

  const renderEvents = () => {
    // var evs = _.orderBy(events, ['date'], ['asc']);
    // var showall = showids.includes(name);
    // var showIgnored = ignoreids.includes(name);
    // return evs.map((event) => {
    // var hidden = !showall && !(event.isUpdated && !event.isSame)
    // var isIgnored = !event.isUpdated && !event.isSame;
    // var hidden = !showall && !(event.isUpdated && !event.isSame);
    // var selectedid = event.parent ? event.parent?._id : event.child?._id;
    // return <EventDiffItem
    //     onSelect={(flag) => handleEventSelect(selectedid, flag, event.type)}
    //     hidden={showall ?
    //             (!showIgnored && isIgnored) :
    //             (showIgnored ?
    //                 !isIgnored && !(event.isUpdated && !event.isSame):
    //                 hidden
    //             )
    //         }
    //     event={{...event}}
    // />
    // })
    var selectedid = events[index]?.parent
      ? events[index]?.parent?._id
      : events[index]?.child?._id
    var surgevents = _.find(props.importids, { type: events[index]?.type })
    var deletedEvents = _.find(events, { isDeleted: true })

    var selectedvalue = surgevents.ids.includes(selectedid)
      ? 1
      : surgevents.skipids.includes(selectedid)
        ? -1
        : deletedEvents?.ids?.includes(selectedid)
          ? 1
          : 0
    return (
      <EventDiffItem
        onSelect={(flag) =>
          handleEventSelect(selectedid, flag, events[index]?.type)
        }
        event={{ ...events[index] }}
        selectedvalue={selectedvalue}
      />
    )
  }

  const handleChange = (e, name) => {
    if (e.target.checked) setIds([...showids, name])
    else {
      var ids = JSON.parse(JSON.stringify(showids))
      _.remove(ids, (e) => name == e)
      setIds(ids)
    }
  }

  const handleIgnoreChange = (e, name) => {
    if (e.target.checked) setIgnoreids([...ignoreids, name])
    else {
      var ids = JSON.parse(JSON.stringify(ignoreids))
      _.remove(ids, (e) => name == e)
      setIgnoreids(ids)
    }
  }

  const renderFooter = () => {
    var selectedid = events[index]?.parent
      ? events[index]?.parent?._id
      : events[index]?.child?._id
    var surgtype = _.find(props.importids, { type: events[index]?.type })
    var isSelected = surgtype?.ids?.includes(selectedid)
    return (
      <Row justify='start' wrap={false} gutter={10} className='btn-container'>
        {/* <Col>
                    <Button hidden={index == events.length} className="et-cancel-round-btn" type="primary" shape="round">
                        Discard
                    </Button>
                </Col>
                <Col>
                    <Button hidden={index == events.length} className="et-round-btn" type="primary" shape="round">
                        Accept
                    </Button>
                </Col> */}
        <Col hidden>
          <Radio.Group
            className='calendarStatusRadio'
            buttonStyle='solid'
            onChange={(e) =>
              handleEventSelect(selectedid, e.target.value, events[index]?.type)
            }
            value={surgtype ? isSelected : ''}
          >
            <Radio.Button value={false}>Discard</Radio.Button>
            <Radio.Button value={true}>Accept</Radio.Button>
          </Radio.Group>
        </Col>
        <Col>
          <Button
            onClick={() => setIndex(index - 1)}
            disabled={index == 0}
            hidden={index == events.length}
            className='et-round-btn'
            type='primary'
            shape='round'
          >
            {index == events.length ? 'Back' : 'Prev'}
          </Button>
        </Col>
        <Col>
          <Button
            onClick={() => setIndex(index + 1)}
            hidden={index == events.length}
            disabled={index == events.length}
            className='et-round-btn'
            type='primary'
            shape='round'
          >
            {/* {  (isSelected && surgtype) ? 'Next' : 'Skip' } */}
            Next
          </Button>
        </Col>
      </Row>
    )
  }

  const renderPublish = () => {
    return (
      <Row>
        <Col className='modal-padding'>
          <h2>Please publish all the accepted changes.</h2>
          <Row>
            <Button
              onClick={() => setIndex(index - 1)}
              disabled={index == 0}
              className='et-round-btn reminder-btn'
              type='primary'
              shape='round'
            >
              Back
            </Button>
            <Button
              onClick={() => props.acceptChanges()}
              className='et-round-btn reminder-btn'
              type='primary'
              shape='round'
            >
              Publish
            </Button>
          </Row>
        </Col>
      </Row>
    )
  }

  const renderDiffs = () => {
    //     return props.differences.map((difference) => {
    //         return (
    //             <Row>
    //                 <Col flex="auto">
    //                     <Row className="drawer-event-header">
    //                         <Col flex="auto">
    //                             <h2 style={{margin: 0}}>{difference.name}</h2>
    //                             {/* <p> */}
    //                                 {/* <Checkbox
    //                                     checked={showids.includes(difference.name)}
    //                                     onChange={(e) => handleChange(e, difference.name)}
    //                                 >Show All</Checkbox>
    //                                 <Checkbox
    //                                     checked={ignoreids.includes(difference.name)}
    //                                     onChange={(e) => handleIgnoreChange(e, difference.name)}
    //                                 >Show Discarded</Checkbox> */}
    //                             {/* </p> */}
    //                         </Col>
    //                     </Row>
    //                     <Divider />
    //                     <Row>
    //                         <Col flex={"50%"}>
    //                             <h3>
    //                             { props.token?.role == constants.ROLE.COMPANY_ADMIN ? "Master" : "Company"}
    //                             </h3>
    //                         </Col>
    //                         <Col flex={"50%"}>
    //                             <h3>
    //                                 {"Current"}
    //                             </h3>
    //                         </Col>
    //                     </Row>
    //                     {renderEvents(difference.events, difference.name, difference.type)}
    //                     <Divider/>
    //                 </Col>
    //             </Row>
    //         )
    //     })
  }

  console.log(props.importids)

  return (
    <Modal
      className='event-drawer'
      visible={props.details}
      onCancel={() => props.setDetails(false)}
      destroyOnClose
      title={'Reminders'}
      width={'720px'}
      footer={renderFooter()}
    >
      <Row>
        <Col flex='auto'>
          {index == events.length ? renderPublish() : renderEvents()}
        </Col>
      </Row>
    </Modal>
  )
}

EventDiff.propTypes = {
  isLoading: PropTypes.bool,
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.event.isLoading,
    customer: state.profile.customer,
    company: state.profile.company,
    surgerytype: state.event.surgerytype,
    events: state.event.events,
    differences: state.event.differences,
    token: util.verifyToken(state.profile.token, true),
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    getDiffs: (params) => dispatch(getDifference(params)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventDiff)
